import { Injectable } from '@angular/core';
import { Folder } from 'app/models/Folder/folder.model';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { BaseBackendService } from './base-backend.service';
import { SsoAuthService } from './sso.service';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root', // This makes the LeadService globally available throughout the app
})
export class FolderService extends BaseBackendService<Folder> {
    constructor(
        http: HttpClient,
        protected override authService: AuthService,
        ssoService: SsoAuthService
    ) {
        super(http, authService, Folder, 'folders', ssoService);
    }

    getHiddenLeadFolderDetail = (): Observable<any> => {
        const HIDDEN_FOLDER_ENDPOINT = 'hidden-folder/';
        const QUERY_PARAMs = '?shared_folders=true&name=Lead-assets';
        return this.getData('', HIDDEN_FOLDER_ENDPOINT + QUERY_PARAMs).pipe(
            map((hiddenFolderRes) => {
                return hiddenFolderRes['results']?.[0];
            }),
            catchError(async (error) => {
                console.error('Error in getting hidden folder details');
                return this.handleError(error);
            })
        );
    };

    createNewFolder = (folderName: string) => {
        const orgId = this.authService.getCurrentOrganization().id;
        const passedBody = {
            name: folderName,
            organization: orgId,
        };

        this.post(passedBody).subscribe(
            (folderRes: any) => {
                return folderRes;
            },
            (error) => {
                console.error('Error in getting all folder details');
            }
        );
    };
}
